import {rawRequest} from './http';
import {requireSessionAcknowledgement} from './sessionProtocol';

// Compatibility only: no new credential is ever stored here. Removing this
// migration before existing browsers upgrade would strand their workspaces.
const LEGACY_KEY = 'triageflow-workspace';
let confirmedLegacyCredential: string | null = null;

function readLegacyCredential(hasAuthenticatedCookie: boolean): string | null {
  try { return localStorage.getItem(LEGACY_KEY); }
  catch {
    if (!hasAuthenticatedCookie) {
      throw new Error('Your browser blocked workspace storage checks. Allow site storage and retry without clearing browser data.');
    }
    console.warn('Legacy workspace storage is unavailable; keeping the authenticated cookie session. No stored data was removed.');
    return null;
  }
}

export function clearLegacyCredential(): void {
  if (!confirmedLegacyCredential) return;
  try {
    if (localStorage.getItem(LEGACY_KEY) === confirmedLegacyCredential) localStorage.removeItem(LEGACY_KEY);
  } catch {
    console.warn('The old workspace credential was revoked, but browser storage cleanup failed. Access continues through the secure cookie.');
  }
  finally { confirmedLegacyCredential = null; }
}

export async function migrateLegacySession(signal?: AbortSignal, hasAuthenticatedCookie = false): Promise<boolean> {
  confirmedLegacyCredential = null;
  const credential = readLegacyCredential(hasAuthenticatedCookie);
  if (!credential) return false;
  const response = await rawRequest('/session/migrate', {
    method: 'POST', headers: {Authorization: `Bearer ${credential}`}, signal,
  });
  await requireSessionAcknowledgement(response, 'Could not restore your existing workspace. No data was changed.');
  confirmedLegacyCredential = credential;
  return true;
}